import PageShell from "@/components/founding/PageShell";
import SeoHead from "@/components/seo/SeoHead";
import {
    PAGE_SEO,
    softwareApplicationSchema,
    organizationSchema,
} from "@/lib/seo";

export const BUDGET_NOTE =
    "Budgetary, for the pro to confirm. Example data, pending contractor bids.";

export const FLORIDA_EXAMPLES = [
    {
        id: "fl-dental-office",
        name: "Dental office",
        image: "/examples/fl-dental-office-overlay.png",
        base: "$14,101–$35,459",
        withBackflow: "$15,601–$44,459",
        mostLikely: "about $24,800",
    },
    {
        id: "fl-strip-retail",
        name: "Strip retail",
        image: "/examples/fl-strip-retail-overlay.png",
        base: "$23,625–$59,949",
        withBackflow: "$25,125–$68,949",
        mostLikely: "about $41,800",
    },
    {
        id: "fl-warehouse-flex",
        name: "Warehouse flex",
        image: "/examples/fl-warehouse-flex-overlay.png",
        base: "$27,190–$67,295",
        withBackflow: "$28,690–$76,295",
        mostLikely: "about $47,200",
    },
];

export default function ExampleLibrary() {
    return (
        <PageShell>
            <SeoHead
                {...PAGE_SEO.examples}
                jsonLd={[softwareApplicationSchema(), organizationSchema()]}
            />
            <div
                className="mx-auto w-full max-w-[1100px] px-6 lg:px-10 py-12"
                data-testid="examples-page"
            >
                <h1 className="fsrs-heading text-white text-4xl sm:text-5xl mb-3">
                    Fictional Florida examples
                </h1>
                <p className="fsrs-mono text-slate-400 text-lg mb-10">
                    Three example plans. The sheets keep their preliminary watermark.
                </p>
                <div className="space-y-12">
                    {FLORIDA_EXAMPLES.map((example) => (
                        <article key={example.id} data-testid={`example-${example.id}`}>
                            <h2 className="fsrs-heading text-white text-2xl mb-4">{example.name}</h2>
                            <img
                                src={example.image}
                                alt={`${example.name} overlay`}
                                className="w-full border border-white/10 bg-white"
                                data-testid={`example-image-${example.id}`}
                            />
                            <dl className="mt-4 grid gap-2 sm:grid-cols-3" data-testid={`example-figures-${example.id}`}>
                                <div>
                                    <dt className="fsrs-label text-slate-500">Base</dt>
                                    <dd className="fsrs-mono text-white text-lg">{example.base}</dd>
                                </div>
                                <div>
                                    <dt className="fsrs-label text-slate-500">With backflow</dt>
                                    <dd className="fsrs-mono text-white text-lg">{example.withBackflow}</dd>
                                </div>
                                <div>
                                    <dt className="fsrs-label text-slate-500">Most likely</dt>
                                    <dd className="fsrs-mono text-white text-lg">{example.mostLikely}</dd>
                                </div>
                            </dl>
                            <p className="fsrs-mono text-amber-200 text-lg mt-4" data-testid={`example-note-${example.id}`}>
                                {BUDGET_NOTE}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </PageShell>
    );
}
